import { exitSearch } from './actions/exitSearch';
import initializeShowReadingPane from './actions/initializeShowReadingPane';
import onNewMessage from './actions/onNewMessage';
import onPrintRow from './actions/onPrintRow';
import onListViewSelectionChange from './orchestrators/ListViewSelectionChangeOrchestrator';
import { LazyAction, LazyImport, LazyModule } from 'owa-bundling';
import { runAfterInitialRender } from 'owa-delayed-initialization';
import { PreviewPaneSelectionSource } from 'owa-preview-pane-store';
import { subscribe } from 'satcheljs/lib/legacy/stitch';
var lazyModule = new LazyModule(function () {
    return System.import(/* webpackChunkName: "MailModuleOrchestrator" */ './lazyIndex');
});
export { initializeShowReadingPane, onNewMessage, onListViewSelectionChange, onPrintRow, PreviewPaneSelectionSource, exitSearch, };
export var lazyCloseImmersiveReadingPane = new LazyAction(lazyModule, function (m) { return m.closeImmersiveReadingPane; });
export var lazyOnCloseCompose = new LazyAction(lazyModule, function (m) { return m.onCloseCompose; });
export var lazyOnReplyOrReplyAllOrForwardMessage = new LazyAction(lazyModule, function (m) { return m.onReplyOrReplyAllOrForwardMessage; });
export var lazyOnSelectingFolder = new LazyAction(lazyModule, function (m) { return m.onSelectingFolder; });
export var lazyOnSxSPreviewPaneClose = new LazyImport(lazyModule, function (m) { return m.onSxSPreviewPaneClose; });
export var lazyOnReadingPanePositionOptionSaved = new LazyAction(lazyModule, function (m) { return m.onReadingPanePositionOptionSaved; });
export var lazyOnSelectMessageAd = new LazyAction(lazyModule, function (m) { return m.onSelectMessageAd; });
// Initialize stitch to listen to action in Options that toggles Focused Inbox
runAfterInitialRender(function () {
    // Type safety without pulling in a string reference and all the code that goes with it
    var stitchName = 'saveReadingPanePositionOptionStitchName';
    subscribe(stitchName, function (newReadingPanePosition) {
        return lazyOnReadingPanePositionOptionSaved.importAndExecute(newReadingPanePosition);
    });
});
//# sourceMappingURL=index.js.map